import { FeatureConfig } from '@cbre/feature-toggles';
import { LogLevel } from '@cbre/logger';
import base from './environment.base';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const featuresConfig: FeatureConfig = {
  tim: true,
  tenancy: true,
  'historical-stats': true,
  'tim-competing-tims': false,
  'wizard-creation': true,
  brand: true,
  // this flag removes NAICs input from on the fly company creation dialog
  'include-NAICS': true,
  // used to show/hide property view PV in stacking plan
  stackingPlanPropertyView: true,
  stackingPlanPropertyViewBuilding: true,
  stackingPlanPropertyViewElevators: true,
  stackingPlanPropertyViewLeaseInfo: true,
  stylishSummary: true,
  isPropertySetEnabled: true,
  sortCompanyContactsManually: true,
  isTypeOfLeaseEnable: true,
  // Availability Calculations New Columns and Logic
  availabilityNewGroups: true,
  // Historical Stats Changes for New Columns, Filter by Periods including Dowloading
  historicalStatChanges: true,
  // Historical Stats Changes to add PRoperty Sets including Downloading
  historicalStatPS: true,
  // Tourbook Enablement
  isTourbookReady: true,
};

export const environment = {
  ...base,
  production: true,
  baseUrl: 'https://uat.marketiq.cbre.com:443/api', // ! no slash at the end required
  // Not server available yet, but required for building process
  spmtBE: 'https://uat.marketiq.cbre.com/api/datastack',
  host: 'https://uat.marketiq.cbre.com',
  cepHost: 'https://uat.miq.cbre.com',
  e2eJson: 'uat',
  s3BucketUrl: 'https://uat.marketiq.cbre.com/aws/',
  s3BucketTicketsUrl: 'https://uat.marketiq.cbre.com/tickets/',
  s3BucketImagesUrl: 'https://uat.marketiq.cbre.com/prop-images/',
  env: 'UAT',
  logEnv: 'uat',
  logLevel: LogLevel.Info,
  debugActions: [],
  /** @deprecated */
  edpMultimediaURI: 'adv-multimedia-np',
  media: {
    originalLocationURI: '/prop-images/',
    thumbLocationURI: '/prop-images/thumb/',
    edpMultimediaKey: 'adv-multimedia-np',
  },
  globalListingsUrl: 'https://preprod-manage.cbrelistings.com/miq/create/',
  featuresConfig,
  // Data Stack host strategy — 'elements' embeds <kads-spdm>; 'legacy' navigates
  // to /kads/data-management/:property_id. Sits at the env top level (not in
  // featuresConfig) so it can remain a string literal while featuresConfig
  // keeps its strict FeatureConfig (boolean | {value:boolean}) type.
  datastackIntegrationMode: 'elements' as const,
  cigConfig: {
    ciq_create_path: 'https://cbrecrm--uat.sandbox.lightning.force.com',
    ciq_path: 'https://cbrecrm--uat.sandbox.my.salesforce.com',
    // TODO: change credential's values
    CIQ_CLIENT_ID: '',
    CIQ_USER: 'cep.integration@cbre.com.crm.uat',
  },
  /**
   * PLEASE NOTE: DataDog is allowed to track only for QA, UAT or PROD,
   * DO NOT BRING this config to any other environment unless specified by Management
   */
  DataDogEnvironment: {
    env: 'uat',
    APP_ID: '20c8e90f-2964-4a37-bfa6-a376b9414a9d',
  },
  TourBookTemplates: {
    ComparisonView: '671cc392f565fb8587419b13', // v2.51.0
    PropertyAvailabilityDetailsView: '671d1570f565fb8587419b15', // v2.51.0
    TourBook: '671ef47dcc06855478cb6890', // v2.51.0
  },
  TemplateHubTourBookTemplates: {
    ComparisonView: '8eb620ac-d095-45c0-b6f5-ba9caed09135', //v2.63.0
    PropertyAvailabilityDetailsView: '9388844c-53ec-404c-8ff2-c039d766ac98', //v2.63.0
    TourBook: 'c5aa4408-e0a2-4c0a-8218-1934f360ebbf', //v2.63.0
  },
  // Dev[1], QA[2], UAT[3], STG[4]
  TemplateHubEnv: '3',
  PvSideBySideTemplates: {
    TemplafyId: '63d33eaaae1b0c696dbd2ac9',
    TemplateHubId: 'd34d92f0-a373-4afe-94b6-a346dce24c0b',
  },
  clarity: {
    projectId: 'ubq3izi126',
  },
  ReportGenerator: {
    FEPrefix: '/rmr/fe',
  },
  LeaseQC: {
    FEPrefix: '/leaseqc/web',
  },
  KADS: {
    FEPrefix: '/kads/web',
  },
  COSTAR_BASE_URL: 'https://product.costar.com/detail/all-properties',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
